import { css } from '@emotion/react';

const getTabPanelCss = css`
  padding: 0;
`;

export default getTabPanelCss;
